import request from '@/utils/request'

/**
 * 查询工具元件
 * @param {Object} params 
 * @returns 
 */
export function listUtilComponent(params) {
  return request({
    url: '/component/util_component/list',
    method: 'GET',
    params,
  })
}

/**
 * 添加工具元件
 * @param {Object} data 
 * @returns 
 */
export function insertUtilComponent(data) {
  return request({
    url: '/component/util_component/insert',
    method: 'POST',
    data,
  })
}


/**
 * 修改工具元件
 * @param {Object} data 
 * @returns 
 */
export function updateUtilComponent(data) {
  return request({
    url: '/component/util_component/update',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function removeUtilComponent(data) {
  return request({
    url: '/component/util_component/remove',
    method: 'POST',
    data,
  })
}


/**
 * 添加工具元件
 * @param {Object} data 
 * @returns 
 */
export function getUtilComponentById(data) {
  return request({
    url: '/component/util_component/getById',
    method: 'get',
    data,
  })
}

